<template>
    <ToolConsumption></ToolConsumption>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ToolConsumption = defineAsyncComponent(() =>
    import("../../components/CNC/ToolConsumption.vue")
);

export default {
    name: "ToolConsumption_Inventory", //The name you are in should not equal the name of the component you are importing.
    components: { ToolConsumption, AuthLayout },
};
</script>
